import { LoadState } from "../../constants/enums";
import {
  IForm,
  IFormLabel,
  IFormLabelOption,
  IFormsState,
} from "./forms.types";

export const initialForm: IForm = {
  form_uuid: null,
  form_name: "",
  form_labels_per_page: 0,

  description: "",
  comment: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  labels: [],
};

export const initialFormLabel: IFormLabel = {
  form_labels_uuid: "",
  form_uuid: "",
  form_name: "",
  form_labels: "",
  form_labels_type: "",
  is_required: 0,
  error_message: "",
  description: "",
  comment: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  labels_options: [],
};

export const initialFormLabelOption: IFormLabelOption = {
  form_labels_options_uuid: null,
  form_labels_uuid: "",
  form_labels: "",
  form_uuid: "",
  form_name: "",
  form_labels_option: "",
  description: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const initialFormsState: IFormsState = {
  list: [],
  data: initialForm,
  totalRecords: 0,
  loading: LoadState.NotLoaded,
  error: null,
};
